import React from 'react'
import { withPrefix } from 'gatsby'
import { textCountryLinea3, textCountrySnake, textCountryTetris } from './replica-tutorialData'
import { LOCALE } from '../../../constants/activity-constants'

const arg = LOCALE === "es-AR"
const IMAGE_BASEPATH = withPrefix('/tutorial/')
const BASENAMES = {
  tetris: 'ESCENARIO PUBERTAD',
  snake: 'ESCENARIO MENSTRUACION',
  linea3: 'ESCENARIO ZONA V',
}
const TutorialData = {}
/// -- TETRIS
TutorialData.tetris = [
  {
    step: 1,
    text: (
      <>
        <b>{textCountryTetris.textTutorial13}</b>
        <br />{textCountryTetris.textTutorial1}
        <br />{textCountryTetris.textTutorial2}
      </>
    ),
    pc: {
      top: 283,
      left: '60%',
    },
    mobile: {
      top: 30,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
  {
    step: 2,
    text: (
      <>
        Una vez creadas las líneas,
        <b>
          <br /> ¡desaparecerán! y ganarás <br />
          10 puntos.
        </b>
      </>
    ),
    pc: {
      top: 384,
      left: 'calc(50% - 150px)',
    },
    mobile: {
      top: 50,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
  {
    step: 3,
    text: (
      <>
        <b>
          Cada vez que caiga un personaje
          <br /> de Nosotras,
        </b>{' '}
        tendrás que buscar una ficha del mismo color para <br />
        ubicarlo.
      </>
    ),
    pc: {
      top: 216,
      left: '60%',
    },
    mobile: {
      top: 50,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
  {
    step: 4,
    text: (
      <>
        <b>¡Es tu Bonus Track,</b> {textCountryTetris.textTutorial3}
      </>
    ),
    pc: {
      top: 295,
      left: '40%',
    },
    mobile: {
      top: 50,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
  {
    step: 5,
    text: (
      <>
        <b>Si te sale la V </b>también será un Bonus Track especial que
        triplicará tus puntos.<b> {textCountryTetris.textTutorial4}</b>
      </>
    ),
    pc: {
      top: 306,
      left: '55%',
    },
    mobile: {
      top: 50,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
  {
    step: 6,
    text: (
      <>
        En este cuadro te aparecerá la próxima ficha que va a caer,{' '}
        <b>{textCountryTetris.textTutorial5}</b>
      </>
    ),
    pc: {
      top: 161,
      left: '50%',
    },
    mobile: {
      top: 180,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
  {
    step: 7,
    text: (
      <>
        <b>Tecla de flecha hacia arriba:</b> {textCountryTetris.textTutorial6}
      </>
    ),
    pc: {
      top: 517,
      left: '50%',
    },
    mobile: {
      top: 'auto',
      bottom: 120,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
  {
    step: 8,
    text: (
      <>
        <b> Tecla de flecha izquierda:</b> {textCountryTetris.textTutorial7}
      </>
    ),
    pc: {
      top: 517,
      left: '50%',
    },
    mobile: {
      top: 'auto',
      bottom: 120,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
  {
    step: 9,
    text: (
      <>
        <b> {textCountryTetris.textTutorial12}</b> {textCountryTetris.textTutorial8}
      </>
    ),
    pc: {
      top: 517,
      left: '50%',
    },
    mobile: {
      top: 'auto',
      bottom: 120,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
  {
    step: 10,
    text: (
      <>
        <b> Tecla de flecha derecha:</b> {textCountryTetris.textTutorial9}
      </>
    ),
    pc: {
      top: 517,
      left: '50%',
    },
    mobile: {
      top: 'auto',
      bottom: 120,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
  {
    step: 11,
    text: (
      <>
        <b> {textCountryTetris.textTutorial10}</b> {textCountryTetris.textTutorial11}
      </>
    ),
    pc: {
      top: 'auto',
      bottom: 200,
      right: '10%',
      left: 'auto',
    },
    mobile: {
      top: 197,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
]
/// -- SNAKE
TutorialData.snake = [
  {
    step: 1,
    text: (
      <>
        <b>{textCountrySnake.textTutorial1} la toalla alrededor del escenario </b> {textCountrySnake.textTutorial2}
      </>
    ),
    pc: {
      top: 226,
      left: '60%',
    },
    mobile: {
      top: 48,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
  {
    step: 2,
    text: (
      <>
        <b>Cada vez que {textCountrySnake.textTutorial3} una gota de sangre,</b> la toalla crecerá y
        ganarás 4 puntos.
      </>
    ),
    pc: {
      top: 106,
      left: '50%',
    },
    mobile: {
      top: 48,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
  {
    step: 3,
    text: (
      <>
        <b>
          Los personajes de Nosotras serán
          <br /> tu Bonus Track,
        </b>{' '}
        y aparecerán en
        <br />
        cualquier momento, ¡{textCountrySnake.textTutorial4}
        {' '}tus puntos!
      </>
    ),
    pc: {
      top: '50%',
      left: '60%',
    },
    mobile: {
      top: 48,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
  {
    step: 4,
    text: (
      <>
        <b>Si te sale la V </b>también <br />
        será un Bonus Track especial
        <br /> que triplicará tus puntos.
      </>
    ),
    pc: {
      top: '30%',
      left: '50%',
    },
    mobile: {
      top: 48,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
  {
    step: 5,
    text: (
      <>
        <b>Tecla de flecha hacia arriba:</b>
        <br />
        {textCountrySnake.textTutorial5} la toalla hacia arriba.
      </>
    ),
    pc: {
      top: 'auto',
      bottom: '30%',
      left: '50%',
    },
    mobile: {
      top: 48,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
  {
    step: 6,
    text: (
      <>
        <b>Tecla de flecha izquierda:</b>
        <br />
        {textCountrySnake.textTutorial1} la toalla a la izquierda.
      </>
    ),
    pc: {
      top: 'auto',
      bottom: '30%',
      left: '50%',
    },
    mobile: {
      top: 48,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
  {
    step: 7,
    text: (
      <>
        <b>Tecla de flecha abajo: </b>
        <br />
        {textCountrySnake.textTutorial1} la toalla hacia abajo.
      </>
    ),
    pc: {
      top: 'auto',
      bottom: '30%',
      left: '50%',
    },
    mobile: {
      top: 48,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
  {
    step: 8,
    text: (
      <>
        <b>Tecla de flecha derecha:</b>
        <br /> {textCountrySnake.textTutorial1} la toalla a la derecha.
      </>
    ),
    pc: {
      top: 'auto',
      bottom: '30%',
      left: '50%',
    },
    mobile: {
      top: 48,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
]
// -- LINEA3
TutorialData.linea3 = [
  {
    step: 1,
    text: (
      <>
        {textCountryLinea3.textTutorial1}
        {!arg &&<br />} y{' '}
        <b>
          cuando {textCountryLinea3.textTutorial2} 3 figuras o más iguales,<br />
          ¡desaparecerán! y ganarás 2 puntos.
        </b>
      </>
    ),
    pc: {
      top: 223,
      left: '50%',
    },
    mobile: {
      top: 48,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
  {
    step: 2,
    text: (
      <>
        <b>
          Cada vez que salga un
          <br />
          personaje de Nosotras, este <br />
          va a ser un Bonus Track,
        </b>{' '}
        {textCountryLinea3.textTutorial3}
      </>
    ),
    pc: {
      top: 240,
      left: '40%',
    },
    mobile: {
      top: 48,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
  {
    step: 3,
    text: (
      <>
        <b>{textCountryLinea3.textTutorial4} dar clic al botón finalizar</b>
        <br />
        si {textCountryLinea3.textTutorial5} terminar el juego antes <br />
        de que acabe el tiempo.
      </>
    ),
    pc: {
      top: '60%',
      left: '50%',
    },
    mobile: {
      top: 198,
      left: 'calc(50% - 150px)',
      width: 300,
    },
  },
]

for (let key in TutorialData) {
  if (arg) {
    TutorialData[key].forEach((element, step) => {
      element.image = `${IMAGE_BASEPATH}${key}/PC-ARG/${BASENAMES[key]} - ${
        step + 1
      }.png`
      element.imageMB = `${IMAGE_BASEPATH}${key}/MB-ARG/${BASENAMES[key]} MB - ${
        step + 1
      }.png`
    })
  }else{
    TutorialData[key].forEach((element, step) => {
      element.image = `${IMAGE_BASEPATH}${key}/PC/${BASENAMES[key]} - ${
        step + 1
      }.png`
      element.imageMB = `${IMAGE_BASEPATH}${key}/MB/${BASENAMES[key]} MB - ${
        step + 1
      }.png`
    })
  }
}
export default TutorialData
